/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NetDocsMatterResponse } from '../models/NetDocsMatterResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class NetDocsService {
    /**
     * @param name 
     * @returns NetDocsMatterResponse Success
     * @throws ApiError
     */
    public static getNetDocsMatters(
name?: string,
): CancelablePromise<Array<NetDocsMatterResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/NetDocs/Matters',
            query: {
                'name': name,
            },
        });
    }

}
